import { TableCell, TableRow } from "@mui/material";
import React from "react";

const NoRows: React.FC = (): React.ReactElement => {
  return (
    <TableRow data-testid="noRowsEl">
      <TableCell align="center" colSpan={12} variant="head">
        - There are no Form Definitions in this Workspace -
      </TableCell>
    </TableRow>
  );
};

export default NoRows;
